function buildRequestBody(bodyParameters) {
    const keys = Object.keys(bodyParameters);
    if (0 === keys.length) return;
    return 1 === keys.length ? bodyParameters[keys[0]] : bodyParameters;
}
export { buildRequestBody };
